import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from 'yup';
import {useMutation} from '@tanstack/react-query';
import {Button} from '@/shadcn_components/ui/button';
import Spinner from '@/components/basic/Spinner';
import {FormProvider, useForm} from 'react-hook-form';
import {useList} from '@refinedev/core';
import SelectMultipleInput, {
  SelectMultipleInputProps,
} from '@/components/refinedev/SelectMultipleInput';
import {useApiService} from '@/lib/ApiService';
import {defaultMutationOptions} from '@/pages/_utils';
import {useEffect} from 'react';
import {InputProps} from '@/hooks/useInput';

type ChangeRoleButtonProps = {
  //   resource: string; //resource like parents, staffs, students, ...
  //   id: BaseID; //id of the userable model
  user: any;
};

export const ChangeRoleButton = (props: ChangeRoleButtonProps) => {
  const {user} = props;
  //   const dialogState = useDialogState();

  const useFormResults = useForm({});

  // update form value if user changed
  useEffect(() => {
    if (user?.roles) useFormResults.reset({roles: user.roles});
  }, [user]);

  const apiService = useApiService();

  const mutation = useMutation<any, any, any>({
    ...defaultMutationOptions,
    mutationFn: async payload => {
      const roles = payload.roles;
      const results = await apiService.users.assignRoles(
        user.id,
        roles.map(item => item.id),
      );
      useFormResults.reset(payload); //reset dirty
      return results;
    },
  });

  async function assignRoles(data) {
    try {
      await mutation.mutateAsync(data);
    } catch (err) {}
  }

  return (
    <>
      <FormProvider {...useFormResults}>
        <form onSubmit={useFormResults.handleSubmit(assignRoles)}>
          {/* <DialogHeader>Phân quyền</DialogHeader> */}
          <div className="flex flex-col gap-y-4">
            <div className="max-w-xl flex flex-col gap-y-4">
              <RoleInput />
            </div>
            <div>
              {useFormResults.formState.isDirty && (
                <Button
                  color="blue"
                  type="submit"
                  // loading={mutation.isLoading}
                  disabled={mutation.isLoading}>
                  {mutation.isLoading && <Spinner />}
                  Lưu
                </Button>
              )}{' '}
            </div>
          </div>
        </form>
      </FormProvider>
    </>
  );
};

export const RoleInput = (props: Partial<SelectMultipleInputProps>) => {
  const {
    source = 'roles',
    label = 'Phân quyền',
    optionText = 'name',
    placeHolder = 'Chọn',
    ...rest
  } = props;
  const listRoleResults = useList({
    resource: 'roles',
    pagination: {pageSize: 9999},
    queryOptions: {refetchOnWindowFocus: false},
  });
  const listRoles = listRoleResults.data?.data || [];

  return (
    <SelectMultipleInput
      source={source}
      optionText={optionText}
      label={label}
      placeHolder={placeHolder}
      {...rest}
      choices={listRoles}
    />
  );
};
